module.exports = __webpack_public_path__ + "img/active-layer11.ef6c9ba6.png";